(() => {
  if (window.__FURMILY_ATOMIC_BUNDLE_ATC__) return;
  window.__FURMILY_ATOMIC_BUNDLE_ATC__ = true;

  const GIFT_IDS = [
    58703621357949,
    58703621390717,
    58703621423485,
    58703621489021,
    58703621521789
  ];
  const SUBSCRIPTION_VARIANT = 58649027150205;
  const SUBSCRIPTION_PLAN = 712250982781;

  const route = (name, fallback) => window.routes?.[name] || fallback;
  const cartJsonUrl = () => {
    const base = route('cart_url','/cart');
    return base.endsWith('.js') ? base : base + '.js';
  };

  const newToken = () => {
    if (window.crypto?.randomUUID) return 'fm-' + window.crypto.randomUUID();
    return 'fm-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 11);
  };

  const getCart = async () => {
    const response = await fetch(cartJsonUrl(), {
      credentials:'same-origin',
      cache:'no-store',
      headers:{ Accept:'application/json' }
    });
    if (!response.ok) throw new Error('Unable to read cart.');
    return response.json();
  };

  const fetchDrawerSection = async () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sections','cart-drawer');
    const response = await fetch(url.toString(), {
      method:'GET',
      credentials:'same-origin',
      cache:'no-store',
      headers:{
        Accept:'application/json',
        'X-Requested-With':'XMLHttpRequest'
      }
    });
    if (!response.ok) throw new Error('Cart drawer refresh failed (' + response.status + ').');
    return response.json();
  };

  const publishCart = (cart) => {
    if (typeof publish !== 'function' || !window.PUB_SUB_EVENTS?.cartUpdate) return;
    try {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source:'furmily-atomic-atc',
        cartData:cart
      });
    } catch (error) {
      console.warn('[FurMily cart publish]', error);
    }
  };

  const buildItems = (variantId, mode, token) => {
    const items = [{
      id:Number(variantId),
      quantity:1,
      properties:{
        _furmily_bundle_token:token,
        _furmily_bundle_role:'fountain',
        _furmily_bundle_mode:mode
      }
    }];

    for (const giftId of GIFT_IDS) {
      items.push({
        id:giftId,
        quantity:1,
        properties:{
          _fm_managed:'gift',
          _fm_gift_slot:String(giftId),
          _furmily_bundle_token:token,
          _furmily_bundle_role:'gift'
        }
      });
    }

    if (mode === 'subscribe') {
      items.push({
        id:SUBSCRIPTION_VARIANT,
        quantity:1,
        selling_plan:SUBSCRIPTION_PLAN,
        properties:{
          _fm_managed:'save-more-subscription',
          _fm_slot:token + '-subscription',
          _furmily_bundle_token:token,
          _furmily_bundle_role:'filters-subscription',
          _furmily_bundle:'fountain-subscribe'
        }
      });
    }

    return items;
  };

  const bind = () => {
    const form = document.getElementById('FurMilyProductForm');
    if (!form || form.dataset.fmAtomicAtcBound === 'true') return;

    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;

    form.dataset.fmAtomicAtcBound = 'true';

    form.addEventListener('submit', async (event) => {
      const button = form.querySelector('button[name="add"][type="submit"]');
      if (!button) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (button.getAttribute('aria-busy') === 'true') return;

      let errorNode = form.querySelector('[data-fm-atc-error]');
      if (!errorNode) {
        errorNode = document.createElement('p');
        errorNode.dataset.fmAtcError = '';
        errorNode.setAttribute('role','alert');
        errorNode.hidden = true;
        errorNode.style.cssText = 'margin:8px 0 0;color:#a23b2a;font-size:12px;font-weight:700;text-align:center;';
        button.insertAdjacentElement('afterend', errorNode);
      }

      const variantId = Number(form.querySelector('[name="id"]')?.value || 0);
      const mode = form.querySelector('[data-fm-bundle-mode]')?.value === 'one-time' ? 'one-time' : 'subscribe';
      const tokenInput = form.querySelector('[data-fm-bundle-token]');
      const token = newToken();
      if (tokenInput) tokenInput.value = token;

      if (!Number.isFinite(variantId) || variantId <= 0) {
        errorNode.textContent = 'Unable to prepare this FurMily offer. Please refresh and try again.';
        errorNode.hidden = false;
        return;
      }

      errorNode.hidden = true;
      errorNode.textContent = '';
      button.disabled = true;
      button.setAttribute('aria-busy','true');
      button.setAttribute('aria-disabled','true');
      window.FurmilySetCheckoutBusy?.(true);
      drawer.setActiveElement?.(button);
      let addSucceeded = false;

      try {
        const payload = {
          items:buildItems(variantId, mode, token),
          sections:'cart-drawer',
          sections_url:window.location.pathname
        };

        const response = await fetch(route('cart_add_url','/cart/add.js'), {
          method:'POST',
          credentials:'same-origin',
          headers:{
            Accept:'application/json',
            'Content-Type':'application/json',
            'X-Requested-With':'XMLHttpRequest'
          },
          body:JSON.stringify(payload)
        });

        const raw = await response.text();
        let data = {};
        try { data = raw ? JSON.parse(raw) : {}; }
        catch { throw new Error('Invalid add-to-cart response (' + response.status + ').'); }

        if (!response.ok || data?.status >= 400 || data?.errors) {
          throw new Error(data?.description || data?.message || 'Unable to add this FurMily bundle.');
        }

        addSucceeded = true;
        let rendered = false;
        if (data.sections?.['cart-drawer']) {
          rendered = drawer.renderContents(data) !== false;
        }

        if (!rendered) {
          const sections = await fetchDrawerSection();
          rendered = drawer.renderContents({ sections }) !== false;
        }

        if (!rendered) {
          throw new Error('The bundle was added, but the cart drawer could not refresh.');
        }

        const cart = await getCart();
        drawer.syncHeaderCartCount?.(cart.item_count);
        publishCart(cart);
        window.setTimeout(() => window.FurMilyOrderCartBundles?.(), 0);
      } catch (error) {
        console.error('[FurMily atomic ATC]', error);

        if (addSucceeded) {
          try {
            const cart = await getCart();
            const bundleExists = (cart.items || []).some(
              (item) => item.properties?._furmily_bundle_token === token
            );
            const sections = await fetchDrawerSection();
            drawer.renderContents?.({ sections });
            drawer.syncHeaderCartCount?.(cart.item_count);
            publishCart(cart);
            window.setTimeout(() => window.FurMilyOrderCartBundles?.(), 0);

            if (bundleExists) {
              errorNode.textContent = '';
              errorNode.hidden = true;
              return;
            }
          } catch (recoveryError) {
            console.warn('[FurMily ATC recovery]', recoveryError);
          }
        }

        errorNode.textContent = error?.message || 'Unable to add to cart. Please try again.';
        errorNode.hidden = false;
      } finally {
        window.FurmilySetCheckoutBusy?.(false);
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.removeAttribute('aria-disabled');
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once:true });
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', bind);
})();